export default "__VITE_ASSET__57f08c4a__"